import './index.css'

import React, { useCallback } from 'react'
import { useDispatch } from 'hooks/use-redux'
import type { Shortlist as ShortlistType } from 'types/shortlist'
import {
  toggleShortlistActive,
  updateShortlist,
} from '@disco/state-management/actions/ShortlistActions'
import ActionMenu from 'components/shortlist/actions/action-menu'
import ShortlistMenu from 'components/shortlist/actions/shortlist-menu'
import ShortlistDuration from 'components/shortlist/shortlist-duration'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import Save from './save'
type Props = {
  shortlist: ShortlistType
  activeUploads: boolean
}

// TODO: Rename to ShortlistHeader or ShortlistItemHeader
const ShortlistActions = ({
  shortlist,
  activeUploads,
}: Props): React.ReactElement<'div'> => {
  const dispatch = useDispatch()
  const { id, title, items, isActive } = shortlist

  const _handleTitleChange = useCallback(
    (evt: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(
        updateShortlist(id, {
          title: evt.target.value,
        }),
      )
    },
    [dispatch, id],
  )

  const _toggleShortlistActive = useCallback(() => {
    dispatch(toggleShortlistActive(id))
  }, [dispatch, id])

  const tracks = items.map(item => item.track)
  return (
    <div className="Shortlist_Header">
      <div className="Shortlist_Header_Content">
        <input
          className="Shortlist_Title"
          data-testid="shortlist-title"
          type="text"
          value={title}
          placeholder="Untitled playlist"
          onChange={_handleTitleChange}
        />
        <div className="Shortlist_Details">
          {tracks.length}{' '}
          <span>{tracks.length === 1 ? 'Track' : 'Tracks'}</span>
          <ShortlistDuration tracks={tracks} />
        </div>
      </div>
      {isActive ? (
        <div className="Shortlist_Header_Actions" data-testid="shortlist-header-actions">
          <ActionMenu shortlistId={id} />
          <ButtonContainer>
            <Save shortlist={shortlist} activeUploads={activeUploads} />

            <ShortlistMenu
              shortlistId={id}
              toggleShortlistActive={_toggleShortlistActive}
            />
          </ButtonContainer>
        </div>
      ) : (
        <div className="Shortlist_Header_Actions" data-testid="shortlist-header-actions">
          <Button compact caption="Expand" onClick={_toggleShortlistActive} />
        </div>
      )}
    </div>
  )
}

export default ShortlistActions
